"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHandlerArgs = void 0;
class EventHandlerArgs {
    constructor(__type, __typeName) {
        this.__type = __type;
        this.__typeName = __typeName;
    }
}
exports.EventHandlerArgs = EventHandlerArgs;
